import { MdCheckCircle, MdRadioButtonUnchecked } from 'react-icons/md';
import { cn } from '../../lib/utils';

const PORT_AGENT_STEPS = [
  { key: 'assigned', label: 'Assigned to port agent' },
  { key: 'with_port_agent', label: 'With port agent' },
  { key: 'out_for_delivery', label: 'Out for delivery' },
  { key: 'onboard_received', label: 'Received onboard' },
  { key: 'delivery_complete', label: 'Complete' },
];

const WAREHOUSE_STEPS = [
  { key: 'assigned', label: 'Assigned to warehouse' },
  { key: 'warehouse_pending_receipt', label: 'Awaiting warehouse confirmation' },
  { key: 'received_by_warehouse', label: 'Received at warehouse' },
  { key: 'delivery_complete', label: 'Complete' },
];

export function DeliveryWorkflowTimeline({ po }: { po: any }) {
  const dest = po?.deliveryDetails?.deliveryDestination;
  const current = po?.deliveryDetails?.workflowStatus;
  const steps = dest === 'warehouse' ? WAREHOUSE_STEPS : dest === 'port_agent' ? PORT_AGENT_STEPS : [];
  if (!steps.length) return null;

  const currentIdx = steps.findIndex(s => s.key === current);

  return (
    <div className="space-y-2">
      <p className="text-[10px] font-bold text-[#0088cc]/65 uppercase tracking-wider">Delivery progress</p>
      {po.deliveryStatusLabel && (
        <p className="text-sm font-bold text-[#0088cc] mb-3">{po.deliveryStatusLabel}</p>
      )}
      <ol className="space-y-2">
        {steps.map((step, idx) => {
          const done = currentIdx >= idx && currentIdx !== -1;
          const active = step.key === current;
          return (
            <li key={step.key} className="flex items-center gap-3 text-sm">
              {done ? (
                <MdCheckCircle className={cn('w-5 h-5 shrink-0', active ? 'text-[#0088cc]' : 'text-emerald-500')} />
              ) : (
                <MdRadioButtonUnchecked className="w-5 h-5 shrink-0 text-[#0088cc]/45" />
              )}
              <span className={cn(done ? 'font-semibold text-[hsl(var(--foreground))]' : 'text-[#0088cc]/65')}>{step.label}</span>
            </li>
          );
        })}
      </ol>
      {(po.deliveryDetails?.statusHistory || []).length > 0 && (
        <div className="mt-4 pt-4 border-t border-[#0088cc]/15 space-y-2">
          <p className="text-[10px] font-bold text-[#0088cc]/65 uppercase">Activity</p>
          {(po.deliveryDetails.statusHistory as any[]).slice().reverse().slice(0, 5).map((h, i) => (
            <p key={i} className="text-xs text-[hsl(var(--muted-foreground))]">
              {h.label} — {h.changedAt ? new Date(h.changedAt).toLocaleString() : ''}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
